import { render, staticRenderFns } from "./housingProperty.vue?vue&type=template&id=298dc290&scoped=true"
import script from "./housingProperty.vue?vue&type=script&lang=js"
export * from "./housingProperty.vue?vue&type=script&lang=js"
import style0 from "./housingProperty.vue?vue&type=style&index=0&id=298dc290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298dc290",
  null
  
)

export default component.exports